import React, { FC } from "react";
import _map from "lodash/map";
import WebdealColorButton from "./WebdealColorButtonV2";

interface Color {
    dedicatedColor: string;
    html?: string;
    id?: string | number;
    name?: string;
    sku?: string;
}

interface WebdealColorPicker {
    colors: Color[];
    id: string;
    selectedColor?: Color;
    setSelectedColor: (color: Color) => void;
    title?: string;
}

const WebdealColorPicker: FC<WebdealColorPicker> = ({
    id,
    colors,
    selectedColor,
    setSelectedColor,
    title = "Velg farge",
}) => {
    return (
        <div className="variation-picker-container-accessory">
            <div className="color-picker-header">
                <span className="color-picker-header__heading">{title}:</span> {selectedColor?.dedicatedColor}
            </div>
            <div className="variation-picker-section color-picker-section">
                {_map(colors, (color) => {
                    return (
                        <WebdealColorButton
                            key={color.id}
                            id={id}
                            color={color}
                            setSelectedColor={(c) => setSelectedColor(c)}
                            selectedColor={selectedColor}
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default WebdealColorPicker;
